// assets
import { IconHeadset } from "@tabler/icons";

// ==============================|| SUPPORT MENU ITEMS ||============================== //

const support = {
    id: "support",
    title: "Support",
    type: "group",
    children: [
        {
            id: "support_ticket_dashboard",
            title: "Support Ticket",
            type: "item",
            url: "/support/support_ticket_dashboard",
            icon: IconHeadset,
            breadcrumbs: false,
        },
    ],
};

export default support;
